// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"49a9296a","574":"beb5bb8a","994":"bc697250"}[chunkId] + ".chunk.css";
};